import { StudentEntry } from '@all-for-one/shared-types'
import { NOT_ASSIGNED } from 'util/parse-class-list'

/**
 * Students with no usable learning level -- the field is missing, or was left
 * at the upload/creation default. Shared between the classroom page and the
 * lesson-launch page so both raise the same alert from one definition.
 */
export const studentsMissingLevel = (students: StudentEntry[] | undefined | null): StudentEntry[] =>
	(students || []).filter(s => !s.difficulty || s.difficulty === NOT_ASSIGNED)
